import React from "react";
import { Radio, Space, Typography } from "antd";
import "./PaymentMethodView.scss";
import { MERCHANT } from "utils/enums";
import { AppleFilled, GoogleCircleFilled } from "@ant-design/icons";

const { Text, Title } = Typography;

export default function PaymentMethod({
  paymentMethod,
  paymentMethodId,
  onClick,
}) {
  const { brand, last4Digits } = paymentMethod ?? {};

  return (
    <div
      key={paymentMethod?.paymentMethodId}
      style={{
        display: "flex",
        alignItems: "center",
        marginBottom: 12,
        cursor: "pointer",
      }}
      onClick={() => {
        onClick(paymentMethod.paymentMethodId);
      }}
    >
      <Space>
        <Radio checked={paymentMethodId === paymentMethod.paymentMethodId} />
      </Space>
      <div className="cardDetails ml-12">
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {
            paymentMethod?.type === MERCHANT.ApplePay && (
              <AppleFilled style={{ fontSize: 20, color: '#373636' }} />
            )
          }
          {paymentMethod?.type === MERCHANT.GooglePay && (
            <GoogleCircleFilled style={{ fontSize: 20, color: '#373636' }} />
          )}
          <span
            style={{ width: 30, height: 26 }}
            className={`cardChip issuer-${brand}`}
          >
            &nbsp;
          </span>
        </div>
        <Text className="cardBrandName">{brand}</Text>
        <Text style={{}}>ending in {last4Digits}</Text>
      </div>
    </div>
  );
}
